<app-title-component [data]="{name : 'Renvoi en compagnie'}"></app-title-component>

<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
       @if (loading) {
        <div class="table-loading-overlay d-flex align-items-center justify-content-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
        }

      <!---->
      <div>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <!-- -->
        <ng-container matColumnDef="collaborateur">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Collaborateur </th>
          <td mat-cell *matCellDef="let row"  data-label="Collaborateur"> {{row.collaborateur}} </td>
        </ng-container>
        <!--
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Code </th>
          <td mat-cell *matCellDef="let row"  data-label=""> {{row.code}} </td>
        </ng-container>
        -->

        <!-- -->
        <ng-container matColumnDef="compagnie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
          <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{row.compagnie_name }} </td>
        </ng-container>

        <!-- -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Total </th>
          <td mat-cell *matCellDef="let row"  data-label="Collaborateurs"> {{row.total }} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openDetails(row)"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>      </div>
  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>